import { useEffect, useState } from 'react';
import ScoringPanelSlab, {
  DisabledScoringPanelSlab,
} from './evaluatorslabscoringpanel'; // DisabledScoringPanelSlab,
import { useSelector } from 'react-redux';
import { RoutineStatus } from '../../models';
// import { useJudgingEnabled } from './hooks';
import { useRoutines } from '../../utilities/clips';
import { Row, Col } from 'react-bootstrap';
import { EvaluatorSlabInput } from './evaluatorslabinput';
import './evaluatorslab.css';

export default function EvaluatorSlab({ round, team, sessionId, judgeType }) {
  // const judgingEnabled = useJudgingEnabled();
  const routines = useRoutines(team.lineupId, round);
  const [selectedType, setSelectedType] = useState('-');

  const inquiry = useSelector(
    (state) => state.evaluator.activeInquiryByLineupId[team.lineupId]
  );

  const edit = useSelector(
    (state) => state.evaluator.activeEditByLineupId[team.lineupId]
  );

  let evalRoutine = null;
  let onAirRoutine = null;
  let onStandbyRoutine = null;

  for (const routine of routines) {
    switch (routine?.status) {
      case RoutineStatus.ON_EVAL:
        evalRoutine = routine;
        break;
      case RoutineStatus.ON_AIR:
        onAirRoutine = routine;
        break;
      case RoutineStatus.STANDBY:
        onStandbyRoutine = routine;
        break;
      default:
        break;
    }
    // Exit early if all are found
    if (evalRoutine && onAirRoutine && onStandbyRoutine) {
      break;
    }
  }

  const disabledInput = !inquiry?.routineId && !edit?.id && !evalRoutine?.id;

  // TODO: Need to handle the optimistic display of the athlete name when clicked.
  const showDisabled =
    (disabledInput && !onAirRoutine?.id && !onStandbyRoutine?.id) ||
    onAirRoutine?.id === 'FAKE-ROUTINE-ID';

  // const airRoutine = routines.find(
  //   (routine) => routine?.status === RoutineStatus.ON_AIR
  // );

  // const standby =
  //   !evalRoutine &&
  //   !airRoutine &&
  //   routines.find(
  //     (routine) => !routine || routine.status === RoutineStatus.STANDBY
  //   );

  // if (judgingEnabled && (inquiry || edit || evalRoutine)) {
  //   return (
  //     <ScoringPanelSlab
  //       team={team}
  //       sessionId={sessionId}
  //       routineId={inquiry?.routineId || edit?.id || evalRoutine?.id}
  //       judgeType={judgeType}
  //     />
  //   );
  // } else {
  //   return (
  //     <DisabledScoringPanelSlab
  //       onAir={airRoutine}
  //       onEval={evalRoutine}
  //       onStandby={standby}
  //       routineId={evalRoutine ? evalRoutine.id : 'FAKE-ROUTINE-ID'}
  //       judgeType={judgeType}
  //     />
  //   );
  // }

  // console.log(disabled)
  // console.log(selectedType)

  // Reset the selected type of there is no routine on eval
  useEffect(() => {
    if (!evalRoutine?.id) {
      setSelectedType('-');
    }
  }, [evalRoutine?.id]);

  //if (judgingEnabled && (inquiry || edit || evalRoutine)) {
  return (
    <div className="evaluatorSlab">
      <Row>
        <Col className="evaluatorSlabPanel">
          {!showDisabled ? (
            <ScoringPanelSlab
              team={team}
              sessionId={sessionId}
              routineId={
                inquiry?.routineId ||
                edit?.id ||
                evalRoutine?.id ||
                onAirRoutine?.id ||
                onStandbyRoutine?.id
              }
              judgeType={judgeType}
              setSelectedType={setSelectedType}
              selectedType={selectedType}
              disabled={disabledInput}
            />
          ) : (
            <DisabledScoringPanelSlab />
          )}
        </Col>
        <Col className="evaluatorSlabInput">
          <EvaluatorSlabInput
            type={selectedType}
            team={team}
            routineId={inquiry?.routineId || edit?.id || evalRoutine?.id}
            sessionId={sessionId}
          />
        </Col>
      </Row>
    </div>
  );
  // } else {
  //   return null;
  // }
}
